import type { MutationHookOptions } from '@apollo/client'
import {
  AccessesDocument,
  InviteAccessDocument,
  InviteAccessMutation,
  InviteAccessMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<InviteAccessMutation, InviteAccessMutationVariables>

export const useInviteAccess = (options?: Options) => {
  const [inviteAccess, { loading }] = useMutation(InviteAccessDocument, {
    ...options,
    extractorFn: (data) => data.apiCoreMutations.inviteApicoreAccess,
  })

  return {
    loading,
    invite(variables: InviteAccessMutationVariables) {
      return inviteAccess({
        variables,
        refetchQueries: [AccessesDocument],
      })
    },
  }
}
